import { brightTurquoise, darkBlue, disabledGray, fontBlack } from '@/refactor/colors'
import { font, FontType } from '@/refactor/fonts'
import styled, { animations, css, muiUtils } from '@/styles'

import Box from '../Box/Box'
import { Grid } from '../GenericComponents/GenericComponents'
import SvgIcon from '../SvgIcon/SvgIcon'

export const SupportSummaryContainer = styled(Box).attrs(() => ({ radius: 5, clickable: false }))<{ mobile?: boolean }>`
	color: ${fontBlack};
	padding: 0;

	${animations.slideInTop.animate(300)}

	${muiUtils.mobile} {
		transform-origin: top center;
		display: ${(p) => (!p.mobile ? 'none' : '')};
		padding-top: ${(p) => p.theme.spacing(2)};
		margin-bottom: 0;
	}
`

export const ItemIcon = styled(SvgIcon).attrs(() => ({ size: 24 }))`
	color: ${darkBlue};
`

export const ItemContent = styled.div``

export const ItemTitle = styled.h4`
	color: ${darkBlue};
	${font(FontType.Comfortaa, { size: 12, weight: 'bold' })};
	text-decoration: none;
	display: block;
`

export const ItemRow = styled(Grid).attrs(() => ({
	columns: [24, '1fr'],
	align: 'flex-start',
	gap: 10,
}))<{
	clickable?: boolean
	hideBorder?: boolean
}>`
	${({ hideBorder: $hideBorder, theme, clickable: $clickable }) => css`
		padding: ${$hideBorder ? theme.spacing(3, 3, 1) : theme.spacing(3)};

		${muiUtils.desktop} {
			padding: ${`${theme.spacing(4)} ${theme.spacing(4)} ${$hideBorder ? theme.spacing(1) : theme.spacing(4)} ${theme.spacing(4)}`};
		}

		${!$hideBorder &&
		`&:not(:last-child) {
			border-bottom: 1px solid ${disabledGray};
		}`}

		${$clickable &&
		`& ${ItemTitle} {
			cursor: pointer;
			&:hover {
				text-decoration: underline;
			}
		}`}
	`}
`

export const HelpText = styled.h3`
	${font(FontType.Comfortaa, { size: 12, weight: 'bold' })}
	color: ${brightTurquoise};
	padding: ${(p) => p.theme.spacing(3)};
	padding-bottom: 0;

	${muiUtils.mobile} {
		:first-child {
			padding-top: 0;
		}
	}

	${muiUtils.desktop} {
		padding: ${(p) => p.theme.spacing(4)};
		padding-bottom: 0;
	}
`
